import { defaultApiState } from '@/store/types/general.types';
import { CourseLicenseTemplateState } from './course-license-template.types';

export const courseLicenseTemplateState: CourseLicenseTemplateState = {
  apiState: {
    getPaginatedCourseLicenseTemplates: defaultApiState,
    getAvailableReplacers: defaultApiState,
    validateLicenseTemplatePlaceholders: defaultApiState,
    generateCourseLicensePreviewFromTemplate: defaultApiState,
    createCourseLicenseTemplate: defaultApiState,
    updateCourseLicenseTemplate: defaultApiState,
    deleteCourseLicenseTemplate: defaultApiState
  },
  paginatedCourseLicenseTemplates: undefined,
  availableReplacers: undefined,
  validatePlaceholderResponse: undefined,
  courseLicensePreview: undefined
};
